import { api } from "../AxiosInstance";
import {
  IFederationCreateRequest,
  IFederationUpdateRequest,
  IFederationListResponse,
  IFederationResponse,
} from "../interfaces/federation.interface";
import {
  IOnboardingFormData,
  IOnboardingResponse,
} from "../interfaces/onboarding.interface";

const FederationService = {
  // Create Federation Admin Registration (Enterprise Federation)
  createFederationAdmin: async (
    data: IOnboardingFormData
  ): Promise<IOnboardingResponse> => {
    try {
      const response = await api.post("/enterprise/registration/fed-admin", {
        name: data.name,
        username: data.username,
        email: data.email,
        password: data.password,
        phoneNumber: data.phoneNumber,
        identifier: data.identifier,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error creating federation admin:", error);
      throw error;
    }
  },

  // Get all federations for the current enterprise
  getFederations: async (): Promise<IFederationListResponse> => {
    try {
      const response = await api.get("/enterprise/federations");
      return response.data;
    } catch (error) {
      console.error("Error fetching federations:", error);
      throw error;
    }
  },

  // Get a specific federation by ID
  getFederationById: async (id: number): Promise<IFederationResponse> => {
    try {
      const response = await api.get(`/enterprise/federations/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching federation:", error);
      throw error;
    }
  },

  // Create a new federation
  createFederation: async (
    federationData: IFederationCreateRequest
  ): Promise<IFederationResponse> => {
    try {
      const response = await api.post(
        "/enterprise/federations",
        federationData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating federation:", error);
      throw error;
    }
  },

  // Update an existing federation
  updateFederation: async (
    id: number,
    federationData: IFederationUpdateRequest
  ): Promise<IFederationResponse> => {
    try {
      const response = await api.put(
        `/enterprise/federations/${id}`,
        federationData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating federation:", error);
      throw error;
    }
  },

  // Delete a federation
  deleteFederation: async (id: number): Promise<IFederationResponse> => {
    try {
      const response = await api.delete(`/enterprise/federations/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting federation:", error);
      throw error;
    }
  },

  // Get federation statistics
  getFederationStats: async (): Promise<any> => {
    try {
      const response = await api.get("/enterprise/federations/stats");
      return response.data;
    } catch (error) {
      console.error("Error fetching federation stats:", error);
      throw error;
    }
  },
};

export default FederationService;
